import InnerComponent from '@Components/Settings/MyProfile';
import orgContainer from '@Components/AppContainer';

const MyProfile = () => ((orgContainer(InnerComponent)));
export default MyProfile;
